import { useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { Alert } from '@mui/material'

import { AppContext } from '/providers/app-context'
import PageWrapper from '/components/page-wrapper'
import SynchroniseDialog from '/components/templates/synchronise-dialog'
import TemplateMenu from '/components/templates/template-nav-menu'
import HelpText from '/help/synchronise'

const Synchronise = () => {
  const { templates, processing, setProcessing, refreshTemplates } = useContext(AppContext)
  const { templateId } = useParams()

  useEffect(() => {
    refreshTemplates()
  }, [templateId])

  const template = useMemo(
    () => templates.find(item => item.template_id === templateId) ?? null,
    [templates, templateId]
  )

  return (
    <PageWrapper title={template ? `Synchronise Passes (${template.name})` : 'Synchronise Passes'} HelpText={HelpText} heading={template ? `Synchronise Passes (${template.name})` : 'Synchronise Passes'} selectedTemplate={template} menu={<TemplateMenu template={template} processing={processing} setProcessing={setProcessing} />}>
      {!template && <Alert severity="info" sx={{ m: 3 }}>Select Synchronise from a template’s menu to begin.</Alert>}
      {template && <SynchroniseDialog page open template={template} processing={processing} setProcessing={setProcessing} />}
    </PageWrapper>
  )
}

export default Synchronise
